import { forwardRef } from "react";

import { cn } from "@/lib/utils";

export const InfoIcon = forwardRef<SVGSVGElement, React.ComponentProps<"svg">>(
  ({ className, ...props }, ref) => (
    <svg
      aria-hidden="true"
      className={cn("size-3.5 text-cool-gray", className)}
      ref={ref}
      viewBox="0 0 14 14"
      {...props}
    >
      <path
        clipRule="evenodd"
        d="M7 0C3.136 0 0 3.136 0 7s3.136 7 7 7 7-3.136 7-7-3.136-7-7-7zm0 11.5c-.44 0-.8-.45-.8-1v-4c0-.55.36-1 .8-1 .44 0 .8.45.8 1v4c0 .55-.36 1-.8 1zm-.654-7.143c.327.328.991.32 1.31 0 .32-.32.329-.983 0-1.311-.327-.328-.983-.328-1.31 0-.328.328-.328.983 0 1.311z"
        fill="currentColor"
        fillOpacity="0.64"
        fillRule="evenodd"
      />
    </svg>
  )
);
